module.exports = __webpack_public_path__ + "static/media/Concord.8abca1e2.jpg";